"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _constants = require("../constants");

var _node = _interopRequireDefault(require("./node"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.tree-view-node-parent-node-container {\n  height: 3rem; }\n  .tree-view-node-parent-node-container-remove-padding {\n    height: unset; }\n  .tree-view-node-parent-node-container-single-environment-select {\n    width: 100%; }\n    .tree-view-node-parent-node-container-single-environment-select-checked {\n      background-color: #e0e0e0; }\n    .tree-view-node-parent-node-container-single-environment-select:hover {\n      background-color: #e0e0e0;\n      cursor: pointer; }\n\n.tree-view-node-container {\n  height: fit-content;\n  min-width: 19rem;\n  position: relative; }\n\n.tree-view-node-container:first-child {\n  margin-left: 0; }\n\n.tree-view-node-parent-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-width: 0;\n  padding: 0.75rem 1rem;\n  height: 3rem;\n  box-sizing: border-box; }\n  .tree-view-node-parent-container-remove-padding {\n    height: unset;\n    padding: unset; }\n  .tree-view-node-parent-container .tree-view-node-content {\n    display: flex;\n    align-items: center; }\n\n.tree-view-node-parent-icon {\n  margin-right: 0.5rem;\n  display: flex;\n  align-items: center; }\n\n.tree-view-node-parent-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 0;\n  color: #393939;\n  font-family: \"OpenSansRegular\";\n  font-size: 0.875rem;\n  letter-spacing: 0.02rem;\n  margin-right: 0.5rem; }\n\n.tree-view-node-parent-icon {\n  color: #6f6f6f; }\n\n.tree-view-node-left-empty-padding {\n  margin-left: 1.5rem; }\n\n.tree-view-table-name-cell-content {\n  display: flex;\n  gap: 0.375rem; }\n\n.tree-view-node-disabled .tree-view-node-parent-text {\n  color: #a8a8a8; }\n\n.tree-view-node-disabled .tree-view-node-dir-icon {\n  color: #a8a8a8; }\n\n.tree-view-node-disabled:hover {\n  background-color: transparent;\n  cursor: not-allowed; }\n";
  var fileName = "compone_treeNodes";
  var element = document.querySelector("style[data-sass-component='compone_treeNodes']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var TreeNodes = function TreeNodes(_ref) {
  var nodes = _ref.nodes,
      updateCount = _ref.updateCount,
      filter = _ref.filter,
      searchText = _ref.searchText,
      onChange = _ref.onChange,
      readOnly = _ref.readOnly,
      hideCheckboxes = _ref.hideCheckboxes,
      singleSelect = _ref.singleSelect,
      singleSelectRadio = _ref.singleSelectRadio,
      allowOnlyLeafSelection = _ref.allowOnlyLeafSelection,
      _ref$allowRootSelecti = _ref.allowRootSelection,
      allowRootSelection = _ref$allowRootSelecti === void 0 ? true : _ref$allowRootSelecti,
      _ref$rootLeafNodesFir = _ref.rootLeafNodesFirst,
      rootLeafNodesFirst = _ref$rootLeafNodesFir === void 0 ? false : _ref$rootLeafNodesFir;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      modifiedNodes = _useState2[0],
      setModifiedNodes = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      filteredNodes = _useState4[0],
      setFilteredNodes = _useState4[1];

  (0, _react.useEffect)(function () {
    setFilteredNodes((0, _utils.getFilteredNodes)(modifiedNodes, filter, searchText, singleSelect, rootLeafNodesFirst));
  }, [filter, searchText]);
  (0, _react.useEffect)(function () {
    initilalizeNodes();
  }, [updateCount]);

  var handleCheckboxClick = function handleCheckboxClick(_ref2) {
    var id = _ref2.id,
        checked = _ref2.checked;
    var updatedNodes = (0, _utils.findAndUpdateCheckedStatus)(id, checked, modifiedNodes, singleSelect);
    updateNodes(updatedNodes);

    if (typeof onChange === 'function') {
      onChange((0, _utils.getSelectedItems)(updatedNodes));
    }
  };

  var expandIconClickHandler = function expandIconClickHandler(nodeId) {
    var updatedNodes = (0, _utils.toggleNodeExpansion)(modifiedNodes, nodeId);
    updateNodes(updatedNodes);
  };

  var initilalizeNodes = function initilalizeNodes() {
    var nodesToRender = (0, _utils.getNodesToRender)(_toConsumableArray(nodes), singleSelect, rootLeafNodesFirst);
    setModifiedNodes(nodesToRender);
    setFilteredNodes((0, _utils.getFilteredNodes)(nodesToRender, filter, searchText, singleSelect, rootLeafNodesFirst));
  };

  var updateNodes = function updateNodes(updatedNodes) {
    setModifiedNodes(updatedNodes);
    setFilteredNodes((0, _utils.getFilteredNodes)((0, _utils.getNodesToRender)(updatedNodes, singleSelect, rootLeafNodesFirst), filter, searchText, singleSelect, rootLeafNodesFirst));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.TreeNodeClasses.container
  }, filteredNodes === null || filteredNodes === void 0 ? void 0 : filteredNodes.map(function (node) {
    return /*#__PURE__*/_react.default.createElement(_node.default, {
      node: node,
      expandIconClickHandler: expandIconClickHandler,
      handleCheckboxClick: handleCheckboxClick,
      readOnly: readOnly,
      hideCheckboxes: hideCheckboxes,
      singleSelect: singleSelect,
      singleSelectRadio: singleSelectRadio,
      allowOnlyLeafSelection: allowOnlyLeafSelection,
      allowRootSelection: allowRootSelection,
      key: "tree-node-".concat(node._id)
    });
  }));
};

var _default = TreeNodes;
exports.default = _default;